import { FiShare2 } from "react-icons/fi";
import { isBrowser } from "utils/next";
import { track } from "utils/tracker";
import { filtersText } from "utils/metadata";
import { questionnairePath } from "utils/questionnaire";

import { QuestionnaireComponentProps } from "components/questionnaire";

interface ShareHandlerProps {
  origin: string;
  questionnaire: QuestionnaireComponentProps;
  text?: string;
}

export default function ShareHandler(props: ShareHandlerProps): JSX.Element {
  const { origin, text, questionnaire } = props;

  const disabled = !questionnaire;

  function handleShare() {
    const eventProperties = {
      origin,
      share_medium: "device_native",
      url: questionnairePath(questionnaire)
    };
    track("Clicked to share questionnaire", eventProperties);
    navigator
      .share({
        title: "vstiba.com",
        text: `Simulado ${filtersText(questionnaire)} | Vstiba`,
        url: questionnairePath(questionnaire)
      })
      .then(() => {
        track("Shared questionnaire", eventProperties);
      })
      .catch((exception) => {
        if (exception.message !== "Share canceled") {
          throw exception;
        }

        track("Canceled questionnaire share", eventProperties);
      });
  }

  if (!isBrowser() || !navigator.share) return <></>;

  return (
    <div onClick={handleShare} data-disabled={disabled}>
      {text ? (
        <button className="btn btn-secondary w-full">{text}</button>
      ) : (
        <FiShare2 size={22} />
      )}
    </div>
  );
}
